import React, { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import SocialStats from "./components/SocialStats";
import CourseSection from "./components/CourseSection";
import WorkWithMeSection from "./components/WorkWithMeSection";
import FavoritesSection from "./components/FavoritesSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";
import CustomCursor from "./components/CustomCursor";
import { Toaster } from "./components/ui/sonner";
import Lenis from "lenis";

function App() {
  useEffect(() => {
    // Initialize smooth scrolling (slow, elegant)
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 0.9,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="relative" data-testid="app-container">
        {/* Subtle noise/grain texture overlay */}
        <div className="noise-overlay" />

        {/* Luxury custom cursor */}
        <CustomCursor />

        {/* Main content */}
        <Navbar />
        <main>
          <HeroSection />
          <SocialStats />
          <CourseSection />
          <WorkWithMeSection />
          <FavoritesSection />
          <SubscribeSection />
        </main>
        <Footer />

        <Toaster position="bottom-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
